export default {
  faqTitle: 'Fiba Emeklilik ve Hayat A.Ş. Hakkında Merak Edilen Sorular',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  products: {
    title: 'Fiba Emeklilik Ürünleri',
    buttons: [
      {
        id: 1,
        title: 'BİREYSEL EMEKLİLİK SİSTEMİ BAŞVURUSU',
        class: 'company--btn--icons fas fa-hand-holding-usd fa-2x mr-2',
        path: 'FibaEmeklilikRetirement'
      }
    ]
  },
  introContent: {
    title: 'Fiba Emeklilik ve Hayat A.Ş. Hakkında',
    content: [
      {
        paragraph:
          'Fiba Emeklilik ve Hayat A.Ş. 2012 yılında kurulmuştur. İlk günden bu yana güvenilerek tercih edilen bir Hayat Sigortası ve Bireysel Emeklilik şirketi olma vizyonu ile yola çıkmıştır.'
      },
      {
        paragraph:
          'Fiba Grubu çatısı altında köklü bir kültürün mirasçısı olan şirket, Bireysel Emeklilik başta olmak üzere Hayat Sigortası ve Sağlık Sigortası branşlarında da faaliyet göstermektedir.'
      },
      {
        paragraph:
          'Fiba Grubu ise 1987 yılında Hüsnü M. Özyeğin tarafından kurulmuştur.'
      },
      {
        paragraph:
          'Fibaemeklilik 2014 yılında CIV Hayat Sigorta AŞ’nin tüm portföyünün devralmıştır. CIV Hayat Sigorta’ya ait olan Kredi Hayat ve Birikimli Hayat Sigorta poliçeleri Fibaemeklilik’e aktararak müşteri kitlesini genişletmiştir. '
      },
      {
        paragraph:
          "2016 yılında ise Ergo Emeklilik ve Hayat'ın tüm hisselerinin satın alarak portföyünü arttırmıştır."
      }
    ]
  },
  questions: [
    {
      title: 'Fiba Emeklilik ve Hayat Ürün Çeşitleri Nelerdir?',
      content: [
        {
          paragraph:
            'Fibaemeklilik 4 kategoride sigortalılarına ürün sunmaktadır:',
          subList: [
            'Emeklilik Ürünleri',
            'Sağlık Ürünleri',
            'Hayat Ürünleri',
            'Eğitim Ürünleri'
          ]
        }
      ]
    },
    {
      title: 'Fiba Emeklilik Bireysel Emeklilik Sistemi Nedir?',
      content: [
        {
          paragraph:
            'BES - Bireysel Emeklilik Sistemi, emeklilik döneminde ek gelir elde etmek isteyenlerin refah seviyeni arttırmak için hazırlanmış sigorta ürünüdür.',
          subList: null
        },
        {
          paragraph:
            'Bireysel Emeklilik sistemine kayıt olarak, birikim yapabilir, üstelik emekli olabilirsiniz. Sistemde en az 10 yıl kalarak ve 56 yaşını tamamlayarak emekliliğe hak kazanabilirsiniz. ',
          subList: null
        },
        {
          paragraph:
            'Bireysel Emeklilik sistemi kapsamında aylık yatıracağınız bütçeler %25 Devlet Katkısı ile artar. Aylık ödeme yapmak istemeyen kişiler 3 aylık, 6 aylık veya yıllık olacak şekilde ödeme periyodunu kendileri belirleyebilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Fiba Emeklilik Poliçe Sorgulama Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Fiba Emeklilik kapsamında var olan poliçeleriniz için şirketin web sitesinden sorgulama işlemi yapabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Fiba Emeklilik ve Hayat A.Ş. Online İşlemler menüsünden Bireysel ya da Kurumsal girişi seçerek, sisteme giriş yapabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Fiba Emeklilik Poliçe Fiyatı Nasıl Alınır?',
      content: [
        {
          paragraph:
            'Fiba Emeklilik poliçe fiyatlarını değerlendirmek için web sitemizden fiyat teklif formunu doldurabilirsiniz. ',
          subList: null
        },
        {
          paragraph:
            'Fiba Emeklilik Alokasko’nun anlaşmalı sigorta şirketidir. ',
          subList: null
        },
        {
          paragraph:
            'Bireysel emeklilik sistemi kapsamında emekliliğe hazırlanmak istediğiniz tüm anlarda yanınızdayız!',
          subList: null
        }
      ]
    }
  ]
}
